// extracted by mini-css-extract-plugin
module.exports = {"content":"main_content_3GWqe","noCompany":"main_noCompany_V2_oL","noCompanyIcon":"main_noCompanyIcon_2TJ-b","noCompanyTip":"main_noCompanyTip_1OTvA"};